import styled from 'styled-components'

export const StyledPowerByWsc = styled.div`
  font-size: 12px;
  color: #fff;
  flex: 1;
  margin-left: 5px;
`
